import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  const educationData = [
    {
      title: "Bachelor of Computer Applications",
      subTitle: "Veer Narmad South Gujarat University (2017 - 2020)",
      result: "7.5 CGPA",
      company_link: "https://vnsgu.ac.in/",
      des: "Studied IT related subjects like Operating Systems, DBMS, OOPS, App Development, Web Development, Compiler Design etc."
    },
    {
      title: "Higher Secondary Education",
      subTitle: "I C Gandhi High School (2015 - 2017)",
      result: "65.15%",
      company_link: "https://surat.nic.in/",
      des: "Studied in this school from 11th to 12th std."
    },
    {
      title: "Primary & Secondary School Education",
      subTitle: "Suman High School No 3 (2005 - 2015)",
      result: "94.20%",
      company_link: "#",
      des: "Studied in this school from Nursery to 10th std."
    }
  ];

  const certData = [
    {
      title: "Flutter Developer (Mobile)",
      subTitle: "UPQOR Private Limited - (Dec,2021 - May,2023)",
      result: "Onsite",
      company_link: "https://upqor.com/",
      des: "Mobile app development and various projects using Flutter."
    },
    {
      title: "Complete Web & Mobile App Development",
      subTitle: "Karon infotech - (2019)",
      result: "Onsite",
      company_link: "https://karoninfotech.com/",
      des: "Web & Mobile app development course."
    }
  ];

  return (
    <div className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-16">
      {/* Education */}
      <div className="w-full lgl:w-1/2">
        <div className="py-6 font-titleFont flex flex-col gap-3 mb-8">
          <p className="text-sm text-cyan-400 tracking-[4px] uppercase">Academic</p>
          <h2 className="text-2xl md:text-3xl font-bold text-white">Education</h2>
        </div>
        <div className="w-full border-l-2 border-cyan-500/30 flex flex-col gap-6 pl-8">
          {educationData.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <ResumeCard {...item} Backend="" />
            </motion.div>
          ))}
        </div>
      </div>

      {/* Certificates */}
      <div className="w-full lgl:w-1/2">
        <div className="py-6 font-titleFont flex flex-col gap-3 mb-8">
          <p className="text-sm text-cyan-400 tracking-[4px] uppercase">Certifications</p>
          <h2 className="text-2xl md:text-3xl font-bold text-white">Certificates</h2>
        </div>
        <div className="w-full border-l-2 border-cyan-500/30 flex flex-col gap-6 pl-8">
          {certData.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <ResumeCard {...item} Backend="" />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Education
